import React from 'react';
import { useState } from "react";
import './generic.css';



const faqData = [
    {
        question: "What are generic medicines and how do they compare to brand-name drugs?",
        answer:
            "Generic medicines are bioequivalent to their brand-name counterparts, meaning they deliver the same amount of the active ingredient into your bloodstream in the same amount of time. The primary difference is the price, as generics don't carry the high costs of research, development, and marketing. Choosing a generic medicine is a safe, effective, and affordable way to manage your health."
    },
    {
        question: "What are the mandatory safety and quality validations for approving generic medicines?",
        answer:
            "Regulatory bodies like the FDA require generic medicines to pass strict safety and quality tests before approval. Manufacturers must prove their product is bioequivalent to the original, delivering the same results in the body. Combined with regular inspections of manufacturing plants, this process guarantees that generics meet the highest standards and are just as trustworthy as brand-name drugs."
    },
    {
        question: "What are the benefits of generic medicines?",
        answer:
            "Generic medicines offer a win-win: they provide the same high-quality treatment as brand-name drugs but at a much lower cost. They are proven to be equally effective and safe. By choosing generics, you're making a great decision for both your health and your wallet."
    }
];


const Generic = () => {




    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };


    return (
        <>
            <div className='faq-section-container' data-aos="fade-up">
                <section className="faq-section">
                    <h2>Understanding Generic Medicines</h2>
                    <div className="faq-container">
                        {faqData.map((item, index) => (
                            <div
                                className={`faq-item ${activeIndex === index ? "active" : ""}`}
                                key={index}
                                onClick={() => toggleFAQ(index)}
                            >
                                <div className="faq-question">
                                    {item.question}
                                    <span>{activeIndex === index ? "-" : "+"}</span>
                                </div>
                                {activeIndex === index && <div className="faq-answer">{item.answer}</div>}
                            </div>
                        ))}
                    </div>
                </section>
            </div>





        </>
    );
}

export default Generic;
